<template>
    <div class="formSection">
        <div class="row form-group">
            <div class="col-12">
                <h4>
                    <label>{{$t('transactions.extraIncomeCashregisterOff')}}</label>
                </h4>
            </div>
        </div>
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
        <hr>
        <div class="row form-group">
            <div class="col col-4 extensionLine">
                <label for="extraIncomePrice" class=" form-control-label">{{$t('transactions.price')}} ({{prefix}}{{suffix}})</label>
            </div>
            <div class="col col-8">

                <InputText id="extraIncomePrice" name="extraIncomePrice" v-model="extraIncomePrice" v-validate="'numeric'" hasToKeyboard="auto" value="" :title="$t('transactions.price')"
                           placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('extraIncomePrice')"/>
                <small class="unit form-text text-muted d-none"></small>
            </div>
        </div>
        <div class="row form-group">
            <div class="col col-4 extensionLine">
                <label for="extraIncomeText" class=" form-control-label">{{$t('transactions.text')}}</label>
            </div>
            <div class="col col-8">
                <InputText id="extraIncomeText" name="extraIncomeText" v-model="extraIncomeText" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('transactions.text')"
                           placeholder="..." dataLayout="t" className="form-control mandatory" :hasError="errors.has('extraIncomeText')"/>
                <small class="unit form-text text-muted d-none"></small>
            </div>
        </div>
        <div class="row form-group">
            <div class="col col-4 extensionLine">
                <label for="extraIncomeDay" class=" form-control-label">{{$t('transactions.date')}}</label>
            </div>
            <div class="col col-8">
                <div class="row ">
                    <div class="col col-12 dateSelectsContainer">
                        <div class="colcol-4">
                            <select id="extraIncomeYear" v-model="extraIncomeYear" class="form-control" name="extraIncomeYear">
                                <option v-for="monthOption in extraIncomeYearOptions" :value="monthOption.value">{{monthOption.text}}</option>
                            </select>
                        </div>
                        <div class="colcol-4">
                            <select id="extraIncomeMonth" v-model="extraIncomeMonth" class="form-control" name="extraIncomeMonth">
                                <option value="1">{{$t('global.monthNames.January')}}</option>
                                <option value="2">{{$t('global.monthNames.February')}}</option>
                                <option value="3">{{$t('global.monthNames.March')}}</option>
                                <option value="4">{{$t('global.monthNames.April')}}</option>
                                <option value="5">{{$t('global.monthNames.May')}}</option>
                                <option value="6">{{$t('global.monthNames.June')}}</option>
                                <option value="7">{{$t('global.monthNames.July')}}</option>
                                <option value="8">{{$t('global.monthNames.August')}}</option>
                                <option value="9">{{$t('global.monthNames.September')}}</option>
                                <option value="10">{{$t('global.monthNames.October')}}</option>
                                <option value="11">{{$t('global.monthNames.November')}}</option>
                                <option value="12">{{$t('global.monthNames.December')}}</option>
                            </select>
                        </div>
                        <div class="colcol-4">
                            <select id="extraIncomeDay" v-model="extraIncomeDay" class="form-control" name="extraIncomeDay">
                                <option v-for="monthOption in extraIncomeDayOptions" :value="monthOption.value">{{monthOption.text}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row form-group">
            <div class="col col-4 ">
            </div>
            <div class="col col-8">
                <button v-on:click="extraIncomeSave()" type="button" class="btn btn-success btn-lgX btn-extraIncome">
                    <i class="fa fa-dot-circle-o"></i> {{$t('transactions.save')}}
                </button>
            </div>
        </div>
    </div>

</template>


<script>
    import LngChooser from '@/components/LngChooser.vue';
    import AlertInPage from '@/components/AlertInPage.vue';
    import Helper from '@/helper/Helper';
    import InputText from '@/components/InputText.vue';
    import SellHeader from "../components/SellHeader";
    import moment from 'moment';
    import Api from '@/api/Api';

    export default {
        name: 'TransactionsExtraIncomeCashregisteroff',
        data() {
            return {
                prefix: "",
                suffix: "",
                extraIncomePrice: "",
                extraIncomeText: "",
                extraIncomeYear: "",
                extraIncomeYearOptions: [],
                extraIncomeMonth: "",
                extraIncomeDay: "",
                extraIncomeDayOptions: [],
                AlertInPage: {
                    type: "", // primary secondary success danger warning info light dark
                    msg: "",
                    delay: 5000,
                }
            };
        },
        watch: {

        },
        mounted() {
            const modul = this;
            modul.setYearsMonths();
            console.log(this.$route.name + " mounded");
            modul.prefix = Helper.getMoneyDefaultDisplayPrefix();
            modul.suffix = Helper.getMoneyDefaultDisplaySuffix();
        },
        methods: {
            cb: function (err, res) {
                const modul = this;
                if (err) {
                    modul.AlertInPage.msg = "global.error";
                    modul.AlertInPage.type = "danger";
                    setTimeout(function (e) {
                        modul.AlertInPage.msg = "";
                    }, Number(5000));
                } else {
                    modul.extraIncomePrice = "";
                    modul.extraIncomeText = "";
                    modul.AlertInPage.msg = "global.success";
                    modul.AlertInPage.type = "success";
                    setTimeout(function (e) {
                        modul.AlertInPage.msg = "";
                    }, Number(5000));
                }
                setTimeout(function () {
//                    SyncHandler.handle({job: 'doSell'});
                }, 1);
            },
            extraIncomeSave: function () {
                const modul = this;
                modul.save(modul.cb, "extraIncome");
            },
            setYearsMonths(){
                const modul = this;
                const actualYears = [moment().get("year"), moment.utc().get("year") - 1, moment.utc().get("year") - 2];
                const actualMonth = moment().get("month") + 1;
                const actualDay = moment().format('D');
                const yearOptions = [];
                Array.prototype.forEach.call(actualYears, function (e) {
                    yearOptions.push({'value': e, 'text': e});
                });
                const dayOptions = [];
                for (let e = 1; e <= 31; e++) {
                    dayOptions.push({'value': e, 'text': e});
                }
                const selectedYear = "" + actualYears[0];
                const selectedMonth = "" + actualMonth;
                const selectedDay = "" + actualDay;
                modul.extraIncomeYearOptions = yearOptions;
                modul.extraIncomeDayOptions = dayOptions;
                modul.extraIncomeYear = selectedYear;
                modul.extraIncomeMonth = selectedMonth;
                modul.extraIncomeDay = selectedDay;
            },
            save(cb, type){
                const modul = this;
                modul.$validator.validateAll().then((result) => {
                    if (result) {
                        const data = {id: null};
                        if (type === "extraIncome") {
                            data.transferreason = 4;
                            data.sum = modul.extraIncomePrice;
                            data.selltext = modul.extraIncomeText;
                            data.wsid = Helper.machineIdSync();
                            const strDate = moment.utc(modul.extraIncomeYear + "-" + modul.extraIncomeMonth + "-" + modul.extraIncomeDay, "YYYY-MM-DD");
                            data.datetime = strDate.format('YYYY-MM-DD 00:00:00');
                        } else {
                            return;
                        }
                        if (window && window.user && window.user.id) {
                            data.id_adminuser = window.user.id;
                        }
                        if (window && window.user && window.user.sync_pk) {
                            data.sync_pk_adminuser = window.user.sync_pk;
                        }
                        data.selltype = 0;
                        data.status = 1;
                      Api.addTransaction({data: data}).then(function (e) {
                        if (e && e.result === true) {
                          console.log(e)
                          if (typeof cb === "function") {
                            cb(null, e.data);
                          }
                        }
                      }, function (err) {
                        if (typeof cb === "function") {
                          cb(err, null);
                        }
                      });

                    } else {
                        // form validate error
                        modul.AlertInPage.msg = "global.saveError";
                        modul.AlertInPage.type = "danger";
                        setTimeout(function (e) {
                            modul.AlertInPage.msg = "";
                        }, Number(5000));
                    }
                });
            },
        },
        components: {
            SellHeader,
            InputText,
            LngChooser,
            AlertInPage,

        },
    };
</script>

